import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@mui/system';
import { COLORS } from '../../styles/color.styles';

export const errorPageStyles = makeStyles((theme: Theme) => ({
	content: {
		padding: 45,
		[theme.breakpoints.down('md')]: {
			padding: 12,
		},
	},
	boxInfoMobil: {
		background: '#FAFAFA',
		border: `2px solid ${COLORS.primary}`,
		boxSizing: 'border-box',
		borderRadius: 4,
		display: 'flex',
		fontSize: 14,
		padding: '16px 16px 8px',
		flexDirection: 'column',
		width: 312,
		marginBottom: '8px',
	},
	boxInfoWeb: {
		background: '#FAFAFA',
		border: `2px solid ${COLORS.primary}`,
		boxSizing: 'border-box',
		borderRadius: 4,
		display: 'flex',
		fontSize: 14,
		padding: '16px 16px 8px',
		flexDirection: 'column',
		width: 430,
		marginBottom: '8px',
	},
	boxRowIconText: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
	},
	contactPhone: {
		textAlign: 'center',
		color: COLORS.secondary,
		marginTop: 8,
	},
	boxInfoText: {
		color: COLORS.primary,
		fontStyle: 'normal',
		lineHeight: '22px',
		letterSpacing: '0.02em',
	},
	rocketWrapper: {
		scale: 0.7,
		marginTop: -50
	}
}));
